import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";

// Your Firebase configuration
// Replace these with your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyBJfz-WIlqqD6FsXmX-ZJTMT3gGozprx6E",
  authDomain: "nyaysahayak-d6c6e.firebaseapp.com",
  projectId: "nyaysahayak-d6c6e",
  storageBucket: "nyaysahayak-d6c6e.firebasestorage.app",
  messagingSenderId: "401513427214",
  appId: "1:401513427214:web:1096e7aede990e6dee275f",
  measurementId: "G-XJJ6106SPC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
export default app; 